import React from "react";
import AppointmentHistory from "./tabs/appointmenthistory";
import {
  calenderIcon,
  chatIcon,
  documentIcon,
  iCardIcon,
  paymentIcon,
} from "./svgs";
import PaymentHistory from "./tabs/pamenthistory";
import MessagePatient from "./tabs/messagepatient";
import ICard from "./tabs/iCard";
import Document from "./tabs/Document";

export default function PatientTabs({
  appointmenthistory,
  data,
  paymentshistory,
  isLoading,
  activeTab,
  setActiveTab,
}) {
  const tabClasses = (tab) =>
    `flex flex-1 justify-center items-center gap-3 px-3 py-2.5 text-sm font-inter font-medium shadow rounded-full transition focus:outline-none ${
      activeTab === tab
        ? "bg-[#E17954] text-white"
        : "bg-[#FFFFFF] text-gray-700 hover:bg-gray-100"
    }`;



  const handleSend = (text) => {
    // Replace with your API call
    console.log("Send message:", text);
  };

  return (
    <div className=" overflow-hidden px-4">
      {/* Top Header Bar */}
      {/* <div className="px-4 py-2 text-sm font-semibold text-gray-700 text-start border-b border-[#F1F5F9] bg-gradient-to-r from-[rgba(80,134,154,0.05)] to-[rgba(80,134,154,0.10)]">
        Patient Records
      </div> */}

      {/* Tab Headers */}
      {/* Tab Headers */}
      <div className="flex gap-2 px-4 mt-2">
        <button
          className={tabClasses("appointments")}
          onClick={() => setActiveTab("appointments")}
        >
          {calenderIcon} Appointment History
        </button>

        <button
          className={tabClasses("payments")}
          onClick={() => setActiveTab("payments")}
        >
          {paymentIcon} Payment History
        </button>
        {/* <button
          className={tabClasses("messagepatient")}
          onClick={() => setActiveTab("messagepatient")}
        >
          {chatIcon} Message Patient
        </button> */}
        <button
          className={tabClasses("icard")}
          onClick={() => setActiveTab("icard")}
        >
          {iCardIcon} iCard
        </button>
        <button
          className={tabClasses("document")}
          onClick={() => setActiveTab("document")}
        >
          {documentIcon} Document
        </button>
      </div>

      {/* Tab Content */}
      <div className="p-4">
        {activeTab === "appointments" && (
          <div>
            <AppointmentHistory
             activeTab={'appointments'}
              data={data}
              appointmenthistory={appointmenthistory}
              isLoading={isLoading}
            />
          </div>
        )}
        {activeTab === "payments" && (
          <div>
            <PaymentHistory
              paymentshistory={paymentshistory}
              isLoading={isLoading}
                 ischartmodal={false}
            />
          </div>
        )}
        {activeTab === "messagepatient" && (
          <div>
            <MessagePatient
           
            data={data}
    
            />
          </div>
        )}
        {activeTab === "icard" && (
          <div>
            <ICard 
              data={data}
            activeTab={'icard'} />
          </div>
        )}
        {activeTab === "document" && (
          <div>
            <Document
              data={data}
              activeTab={'document'}
              onUpload={() => console.log("Upload clicked")}
              onView={(row) => window.open(row.url, "_blank")}
              onDelete={(row) => console.log("Delete", row)}
            />
          </div>
        )}
      </div>
    </div>
  );
}
